import React from 'react';
import { Button } from '@/components/ui/button';
import { CreditCard, X, Lock } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

interface CreditSuggestionBannerProps {
  totalAvailableCredit: number;
  onApply: () => void;
  onDismiss: () => void;
  isProjectLocked?: boolean;
  lockedToProjectName?: string;
}

const CreditSuggestionBanner: React.FC<CreditSuggestionBannerProps> = ({
  totalAvailableCredit,
  onApply,
  onDismiss,
  isProjectLocked = false,
  lockedToProjectName,
}) => {

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center">
          <CreditCard className="h-5 w-5 text-primary" />
        </div>
        <div>
          <p className="font-medium text-foreground">
            This customer has {formatCurrency(totalAvailableCredit)} available credit
          </p>
          <p className="text-sm text-muted-foreground">
            {isProjectLocked && lockedToProjectName ? (
              <span className="flex items-center gap-1">
                <Lock className="h-3 w-3" />
                Currently locked to project: {lockedToProjectName}
              </span>
            ) : (
              'Apply it to this invoice to reduce the amount due'
            )}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="default" size="sm" onClick={onApply}>
          Apply Credit
        </Button>
        <Button variant="ghost" size="icon" onClick={onDismiss} className="h-8 w-8">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default CreditSuggestionBanner;
